import { HeaderNavLink as e } from "../base/HeaderLink.js";
import { useRef as t } from "react";
import n from "clsx";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/components/Header/desktop/DesktopNavLevel3.tsx
function a({ columns: a, isShown: o, teaser: s, className: c, linkComponent: l }) {
	let u = t(!1);
	return o && (u.current = !0), /* @__PURE__ */ r("div", {
		className: n("absolute top-[calc(100%-1px)] -right-16 left-0 xl:-right-22.5", o ? "visible" : "invisible", "max-w-page max-h-[calc(100vh-15rem)] w-[calc(100vw-var(--level3-left-offset))]", "before-white before-white-level3 flex bg-neutral-100 py-6", c),
		children: /* @__PURE__ */ i("div", {
			className: "align-center flex w-full justify-between gap-5",
			children: [/* @__PURE__ */ r("div", {
				className: n("align-center flex justify-between gap-5 overflow-y-auto", s ? "basis-2/5" : "w-full"),
				children: a.map((t, n) => /* @__PURE__ */ r("div", {
					className: "flex min-w-40 grow basis-full flex-col gap-6",
					children: t.map((t) => t.link ? /* @__PURE__ */ r(e, {
						className: "nav-l3",
						link: t.link,
						linkComponent: l,
						tabIndex: 0,
						children: t.label
					}, t.key) : null)
				}, n))
			}), u.current && s ? /* @__PURE__ */ i("div", {
				className: "flex max-w-2/3 grow basis-3/5 flex-col gap-2 overflow-y-auto",
				children: [s.headline ? /* @__PURE__ */ r("span", {
					className: "font-made font-bold uppercase",
					children: s.headline
				}) : null, s.content]
			}) : null]
		})
	});
}
//#endregion
export { a as DesktopNavLevel3 };
